// The book-direct results list lays out two room cards per row at breakpoint
// l. Cards in row r get flex order 2r and that row's expanded panel 2r + 1, so
// a full-width panel sorts after its pair instead of splitting it. Below l the
// list is block flow and order is ignored, so the panel sits under its card.
export const rowOrder = (index) => Math.floor(index / 2) * 2;

export const panelOrder = (index) => rowOrder(index) + 1;

// Two different cards share a two-column row.
export const sameRow = (indexA, indexB) => indexA !== indexB && rowOrder(indexA) === rowOrder(indexB);
